import request from '@/utils/request'

// Po Detail Head
export function getSuccessDetail(param) {
  let data = param
  return request({
    url: `/po/epms4030/getSuccessDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// Po Detail Grid
export function getSuccessDetailGrid(param) {
  let data = param
  return request({
    url: `/po/epms4030/getSuccessDetailGrid`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
